module.exports = __webpack_public_path__ + "static/media/angle-double-right.a00bb421.svg";